import { CartProductsActivation } from "../cart/components/cart";
import removeParam from "../header/components/removeParam";
import equalHeight from "../equalHeight";

function ChangeTab(sender) {
  let topListNavItems = $("#toplist ul.tabs-nav li");
  topListNavItems.removeClass("active");
  var index = $(sender).data("tabIndex");

  if (window.history != undefined && window.history.pushState != undefined) {
    window.history.pushState({}, document.title, removeParam("p", window.location.href));
  }
  if (index > -1) {
    if (history.pushState) {
      history.pushState(null, null, '#' + index);
    }
    else {
      location.hash = '/#' + index;
    }
  }
  else {
    location.hash = "";
    return false;
  }
  GetTabProducts();
  for (var i = 0; i < topListNavItems.length; i++) {
    if ($(topListNavItems[i]).data("tabIndex") === index) {
      $(topListNavItems[i]).addClass("active")
    }
  }
  return false;
}
function GetTabIndex() {
  var hashIndex = window.location.hash;
  if (typeof (hashIndex) == 'undefined' || hashIndex == null || hashIndex == '') {
    hashIndex = "0";
  }
  return parseInt(hashIndex.replace('#', ''));
}
function GetTabProducts() {
  $.ajax({
    type: "GET",
    url: "/api/Toplist/" + GetTabIndex(),
    contentType: "application/json",
    success: function (data) {

      var template = $.templates('#GalleryBlocks');
      var outerHtml = template.render(data);
      $(".product-list-holder").empty();
      $(".product-list-holder").append(outerHtml);

      $(".func-top-list-header").html(data.Header);
      $(".func-top-list-description").html(data.Description);

      $(".product-list-holder .product_item").each(function (i) {
        $(this).find(".product_item-box").prepend("<span class='label-index'>" + (i + 1) + "</span>");
      });
      CartProductsActivation();

      if ($(".grid-view").is(":visible")) {
        $('.grid-view').imagesLoaded().always(function () {
          equalHeight('.grid-view .product-list-holder .product_item-img');
          equalHeight('.grid-view .product-list-holder .title');

        });
      }
    }
  });
}

export { ChangeTab, GetTabIndex, GetTabProducts };